/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../../components/header/index'
import Hero from '../../components/heros/index'
import Container from '../../components/container'
import Plan from '../../components/plan'
import Item from '../../components/planItem'
import Primary from '../../components/buttons/primary'
import WebFeatures from '../../components/webfeatures'
import WebLocation from '../../components/weblocation'
import WebPanel from '../../components/webpanel'
import CTO from '../../components/cto'
import Footer from '../../components/footer'
import Title from '../../components/title'

const Web = () => {
    Title('Web Hosting - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Web Hosting' description='Get started by selecting a Web Hosting plan below' />
            </div>
            <section className="plans py-28">
                <Container>
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-20 gap-y-16 mb-16">
                        <Plan title='Free (Coming Soon)' price='0' renewal='monthly' link='web-hosting/free'>
                            <Item title='1 Website Powered With ADs' />
                            <Item title='5 GB NVMe SSD Storage' />
                            <Item title='LiteSpeed Web Server' />
                            <Item title='Path.net Tbps DDoS Protection' />
                        </Plan>
                        <Plan title='Beginner' price='1.99' renewal='monthly' link='web-hosting/beginner'>
                            <Item title='1 Website' />
                            <Item title='Standard Performance' />
                            <Item title='Unlimited Bandwidth' />
                            <Item title='10 GB NVMe SSD Storage' />
                            <Item title='Free Email Address (Under Your Domain)' />
                            <Item title='Free SSL Certificate' />
                            <Item title='LiteSpeed Web Server' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='One-Click WordPress Installs' />
                        </Plan>
                        <Plan title='Expert' price='7.50' renewal='monthly' link='web-hosting/expert'>
                            <Item title='Unlimited Websites' />
                            <Item title='Unlimited Bandwidth' />
                            <Item title='Unlimited NVMe SSD Storage' />
                            <Item title='Unlimited Email Addresses (Under Your Domain)' />
                            <Item title='Free SSL Certificate' />
                            <Item title='LiteSpeed Web Server' />
                            <Item title='Path.net DDoS Protection' />
                            <Item title='One-Click WordPress Installs' />
                            <Item title='1 Gbit/s Connection' />
                            <Item title='SSH Access' />
                        </Plan>
                    </div>
                    <div className='bg-primary-light shadow-xl p-8 rounded-md text-center'>
                        <h1 className='text-gray-100 font-medium text-2xl mb-2.5'>Unsure what plan is best for you?</h1>
                        <p className='text-gray-300 mb-7'>Contact us and we will help you pick the right choice for your needs.</p>
                        <div className='flex justify-center'>
                            <Primary rounded='sm' arrow={true} length='sm' link='https://billing.stellanode.com/submitticket.php'>Contact Us</Primary>
                        </div>
                    </div>
                </Container>
            </section>
            <WebFeatures />
            <WebPanel />
            <CTO />
            <Footer />
        </main>
    )
}

export default Web